module.exports = __webpack_public_path__ + "img/connect-banner-new.4d7eac46.jpg";